import { lazy, Suspense, type ComponentType, type LazyExoticComponent } from 'react';
import { Route } from 'react-router-dom';
import { RoleBasedRoute } from '@/components/RoleBasedRoute';
import { PageSkeleton } from '@/components/PageSkeleton';
import { ADMIN_PAGE_ROLES } from '@/config/roles';

const Accounts = lazy(() => import('./accounts/Accounts'));
const AccountDetail = lazy(() => import('./accounts/AccountDetail'));
const Vehicles = lazy(() => import('./vehicles/Vehicles'));
const VehicleDetail = lazy(() => import('./vehicles/VehicleDetail'));
const Groups = lazy(() => import('./groups/Groups'));
const GroupDetail = lazy(() => import('./groups/GroupDetail'));
const Zones = lazy(() => import('./zones/Zones'));
const LedgerHealth = lazy(() => import('./ledger/LedgerHealth'));
const SimData = lazy(() => import('./sims/SimData'));
const GeoPointAi = lazy(() => import('./ai/GeoPointAi'));
const ConversationView = lazy(() => import('./ai/ConversationView'));
const FailedTurnView = lazy(() => import('./ai/FailedTurnView'));

/** Contract D's routes, relative to the app layout route ("/"). */
export const FLEET_PAGES: { path: string; Page: LazyExoticComponent<ComponentType> }[] = [
  { path: 'fleet/accounts', Page: Accounts },
  { path: 'fleet/accounts/:id', Page: AccountDetail },
  { path: 'fleet/vehicles', Page: Vehicles },
  { path: 'fleet/vehicles/:id', Page: VehicleDetail },
  { path: 'fleet/groups', Page: Groups },
  { path: 'fleet/groups/:id', Page: GroupDetail },
  { path: 'fleet/zones', Page: Zones },
  { path: 'fleet/ledger', Page: LedgerHealth },
  { path: 'fleet/sims', Page: SimData },
  { path: 'fleet/ai', Page: GeoPointAi },
  { path: 'fleet/ai/conversations/:id', Page: ConversationView },
  { path: 'fleet/ai/failed/:id', Page: FailedTurnView },
];

/**
 * The fleet admin routes, each behind the admin guard the Users and Activity pages use
 * (ADMIN or super-admin; anyone else is sent home). Mounted inside the app layout in src/routes.tsx.
 */
export function fleetRoutes() {
  return FLEET_PAGES.map(({ path, Page }) => (
    <Route
      key={path}
      path={path}
      element={
        <RoleBasedRoute allowedRoles={[...ADMIN_PAGE_ROLES]}>
          <Suspense fallback={<PageSkeleton />}>
            <Page />
          </Suspense>
        </RoleBasedRoute>
      }
    />
  ));
}
